import React from 'react'
import styled from 'styled-components';
import Avatar from '../Avatar';

const Title = styled.p`
    font-size: 16px;
    font-family: 'Roboto-Regular';
    text-overflow: ellipsis;
    color: #262626;
    margin: 0;
    line-height: normal;
    `;

const Tag = styled.p`
    font-family: 'Roboto-Regular';
    color: #0576ff;
    font-size: 12px;
    margin-bottom: 5px;
    line-height: normal;
    `;

const Subtitle = styled.p`
    font-family: 'Roboto-Regular';
    font-size: 12px;
    text-overflow: ellipsis;
    color : #8a8a8a;
    margin: 0;
    line-height: normal;
`;

const Info = ({ title, tag, subtitle, titleStyle, subtitleStyle, ...props }) => (
    <div {...props}>
        <Title style={titleStyle}>{title}</Title>
        {tag && <Tag>{tag}</Tag>}
        {subtitle && <Subtitle style={subtitleStyle}>{subtitle}</Subtitle>}
    </div>
);

export default Info;


// WEBPACK FOOTER //
// ./src/components/Info/Info.js